import { StartPage } from '@/routes/_embaUserLayout/-components/StartPage';
import type { FC } from 'react';

interface PageProps {
  lessonName: string;
  chapterName: string;
  onClickStart: () => Promise<void>;
}

const Page: FC<PageProps> = ({ lessonName, chapterName, onClickStart }) => {
  return (
    <StartPage
      onClick={() => {
        onClickStart().catch(() => {});
      }}
      chapterName={chapterName}
      lessonName={lessonName}
      lessonType="reflection"
    />
  );
};

export default Page;
